import { z } from 'zod';

export const recipeIngredientSchema = z.object({
  ingredientId: z.string(),
  itemId: z.string(),
  itemName: z.string(),
  quantity: z.number(),
  unit: z.string(),
  prepNotes: z.string().optional(),
  isOptional: z.boolean().optional(),
});

export type RecipeIngredient = z.infer<typeof recipeIngredientSchema>;

export const recipeSchema = z.object({
  recipeId: z.string(),
  name: z.string(),
  description: z.string().optional(),
  type: z.enum(['finished', 'sub-recipe', 'component']),
  category: z.string(),
  cuisine: z.string().optional(),
  servings: z.number(),
  servingSize: z.string().optional(),
  prepTime: z.number().optional(),
  cookTime: z.number().optional(),
  prepTimeMinutes: z.number().optional(),
  cookTimeMinutes: z.number().optional(),
  totalTimeMinutes: z.number().optional(),
  yield: z.number().optional(),
  yieldUnit: z.string().optional(),
  difficulty: z.enum(['easy', 'medium', 'hard']).optional(),
  ingredients: z.array(recipeIngredientSchema),
  subRecipeIds: z.array(z.string()).optional(),
  instructions: z.array(z.string()).optional(),
  allergens: z.array(z.string()),
  dietaryFlags: z.array(z.string()),
  costPerServing: z.number().optional(),
  costPerPortion: z.number().optional(),
  imageUrl: z.string().optional(),
  isActive: z.boolean(),
  version: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type Recipe = z.infer<typeof recipeSchema>;

export const recipesResponseSchema = z.object({
  data: z.array(recipeSchema),
  pagination: z.object({
    nextToken: z.string().nullable(),
    totalCount: z.number(),
  }),
});

export type RecipesResponse = z.infer<typeof recipesResponseSchema>;

export interface RecipeFilters {
  type?: 'finished' | 'sub-recipe' | 'component';
  search?: string;
  allergen?: string;
  dietaryFlag?: string;
  limit?: number;
}

export const RECIPE_TYPE_LABELS: Record<string, string> = {
  finished: 'Menu Item',
  'sub-recipe': 'Sub-Recipe',
  component: 'Component',
};

export const DIFFICULTY_LABELS: Record<string, string> = {
  easy: 'Easy',
  medium: 'Medium',
  hard: 'Hard',
};

export const DIFFICULTY_COLORS: Record<string, string> = {
  easy: 'bg-green-100 text-green-800',
  medium: 'bg-amber-100 text-amber-800',
  hard: 'bg-red-100 text-red-800',
};
